import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ProjectFileAvatarComponent } from './project-file-avatar.component';

@NgModule({
  declarations: [
    ProjectFileAvatarComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    RouterModule
  ],
  exports: [
    ProjectFileAvatarComponent
  ]
})
export class ProjectFileAvatarModule { }
